import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserStoreService } from '@hp-core/services/user-store.service';

export const httpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const userStore = inject(UserStoreService);
  const router = inject(Router);

  if (!req.url.includes('/api') || req.url.includes('auth/login')) {
    return next(req);
  }

  return userStore.getRole().pipe(
    map((roles) =>
      roles.some((role) => role.includes('CLIENTE'))
        ? ['dashboard', 'dashboard_cli']
        : ['dashboard_cli', 'dashboard']
    ),
    map(([oldPattern, newPattern]) => {
      const regex = new RegExp(`\\b${oldPattern}\\b`);
      return req.url.replace(regex, newPattern);
    }),
    switchMap((modifiedUrl) =>
      userStore.getToken().pipe(
        switchMap((token) => {
          if (!userStore.isTokenExpired(token ?? '')) {
            return next(
              req.clone({
                url: modifiedUrl,
                setHeaders: { Authorization: `Bearer ${token}` },
              })
            );
          } else {
            router.navigate(['auth', 'login']);
            return of();
          }
        })
      )
    )
  );
};
